import { z } from 'zod'

export const TaxConfig = z.object({
  vat_exempt: z.boolean(),
  seller_country: z.string().optional(),
  default_rate: z.number().optional()
})

export type TaxConfig = z.infer<typeof TaxConfig>
